import React from 'react';
import { BarChart3, DollarSign, Target, Building, TrendingUp, CheckCircle, FileText, ChartLine, Shield, Users, Zap } from 'lucide-react';
import { agendaItems } from '../../utils/constants';
import { colors } from '../../utils/constants';

const iconMap = {
  BarChart3, 
  DollarSign, 
  Target, 
  Building, 
  TrendingUp, 
  CheckCircle, 
  FileText,
  ChartLine,
  // Add portfolio company icons
  Shield,
  Users,
  Zap
};

const Navigation = ({ activeSection, onSectionChange }) => {
  return (
    <div className="w-72 bg-white rounded-xl border shadow-sm flex flex-col">
      <div className="p-6 border-b border-gray-200 flex-shrink-0 flex items-center justify-center">
        <img src="/sv-logo-1.webp" alt="Service Ventures" className="h-12 w-auto" />
      </div>
      <nav className="flex-1 overflow-y-auto p-6 pt-4 space-y-2">
        {/* Main Board Meeting Navigation Items */}
        {agendaItems
          .filter(item => item.visible !== false && item.id !== 'analysis')
          .map((item) => {
            const IconComponent = iconMap[item.icon];
            return (
              <button
                key={item.id}
                onClick={() => onSectionChange(item.id)}
                className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg text-left transition-all ${
                  activeSection === item.id
                    ? 'text-white shadow-md'
                    : 'text-gray-700 hover:bg-gray-50'
                }`}
                style={activeSection === item.id ? {backgroundColor: colors.blue} : {}}
              >
                <IconComponent className="w-5 h-5" />
                <div className="flex-1">
                  <div className="text-sm font-medium">{item.title}</div>
                </div>
              </button>
            );
          })}
        
        {/* Analysis Section */}
        <div className="pt-4 mt-6 border-t border-gray-200"></div>
        <button
          onClick={() => onSectionChange('analysis')}
          className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg text-left transition-all ${
            activeSection === 'analysis'
              ? 'text-white shadow-md'
              : 'text-gray-700 hover:bg-gray-50'
          }`}
          style={activeSection === 'analysis' ? {backgroundColor: colors.blue} : {}}
        >
          <BarChart3 className="w-5 h-5" />
          <div className="flex-1">
            <div className="text-sm font-medium">Analysis</div>
          </div>
        </button>
      </nav>
    </div>
  );
};

export default Navigation;